module.exports = __webpack_public_path__ + "img/arrow.8350fcda.svg";